// extracted by mini-css-extract-plugin
export var attribution = "_bf-4";
export var authorName = "_bf-5";
export var quote = "_bf-3";
export var testimonial = "_bf-2";
export var trustedBy = "_bf-0";
export var trustedByLabel = "_bf-1";